<ng-container *ngIf="cell">
  <!-- Iframe -->
  <div
    class="mode-notebook-cell-run mode-notebook-cell-iframe"
    *ngIf="cell | notebookCellIsHtml"
    [modeNotebookCellResultIframeContent]="cell"
    data-test="iframe"
  ></div>

  <!-- Plain/Text - Html -->
  <div
    class="mode-notebook-cell-run mode-notebook-cell-run-text"
    *ngIf="cell | notebookCellIsPlainText"
    [modeNotebookCellResultContent]="cell"
    data-test="plain-text"
  ></div>

  <!-- Image -->
  <div class="mode-notebook-cell-run" *ngIf="cell.result_type === 'image'" data-test="image">
    <img [src]="cell.content" />
  </div>

  <!-- CSV -->
  <div class="mode-notebook-cell-run mode-notebook-cell-text" *ngIf="cell.result_type === 'csv'" data-test="csv">
    <capra-button text="Export CSV" variant="secondary" color="neutral" size="medium" (clicked)="downloadCSV(cell.content)">
    </capra-button>
  </div>

  <!-- StdError -->
  <div
    class="mode-notebook-cell-stderr"
    *ngIf="cell.result_type === 'stderr'"
    data-test="stderr"
    [modeNotebookCellResultContent]="cell"
  ></div>

  <!-- Error -->
  <div
    class="mode-notebook-cell-run mode-notebook-error-container"
    *ngIf="cell.result_type === 'error'"
    data-test="error"
  >
    <div class="mode-notebook-error-header">
      <capra-icon icon="icon-warning"></capra-icon>
      There was a problem running this cell
    </div>
    <div class="mode-notebook-error-message" [modeNotebookCellResultContent]="cell"></div>
  </div>
</ng-container>
